import { render, staticRenderFns } from "./SelectClientGroupForm.vue?vue&type=template&id=6c21b16f&scoped=true"
import script from "./SelectClientGroupForm.vue?vue&type=script&lang=js"
export * from "./SelectClientGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c21b16f",
  null
  
)

export default component.exports